<div class="tab-container">
  <div class="table-style">
    <p class="table-name sub-form-title no-margin">Year Cycles</p>
    <button class="add-dates no-margin" (click)="openDialogForm()"><span class="material-icons plus-icon">
        add
      </span></button>
  </div>
  <div *ngIf="!yearCycles"> No Cycles Found</div>
  <app-spinner *ngIf="showSpinner; else content"></app-spinner>
  <ng-template #content>
    <div *ngIf="yearCycles?.length" class="box">
      <app-table [tableData]="yearCycles" [tableColumnsNames]="columnNames" (rowSelected)="selectedItems($event)">
      </app-table>
    </div>
  </ng-template>
</div>
<ng-template #formRef>
  <div class="dialog-Container">
    <mat-dialog-actions class="d-inline-block float-right">
      <h4 class="d-inline-block">Add New Cycle For Year</h4>
      <button mat-dialog-close class="dialog-btn-trans text-white">X</button>
    </mat-dialog-actions>
    <mat-dialog-content class="dialog-content">
      <!-- <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p> -->
      <form class="address-form" action="" [formGroup]="yearCycleForm" (submit)="onSubmit()">
        <!-- <mat-form-field  appearance="fill">
                <mat-label>Street No.</mat-label>
                <input matInput formControlName="streetNumber" required/>
                <mat-error *ngIf="addressForm.get('streetNumber').hasError('required')">
                   Please enter
                   <strong>Street No.</strong>
                 </mat-error>
             </mat-form-field>  -->
        <!-- <mat-form-field appearance="fill">
          <mat-label>Year</mat-label>
          <input matInput formControlName="year" pattern="[1-9][0-9]{3}" type="number" [readonly]="isReadonly"
            required />
          <mat-error *ngIf="yearCycleForm.get('year').hasError('required')">
            Please enter year
          </mat-error>
          <mat-error
            *ngIf="!yearCycleForm.get('year').hasError('required') && yearCycleForm.get('year').hasError('pattern')">
            Year max length is 4
          </mat-error>
        </mat-form-field> -->
        <mat-form-field class="">
          <mat-label>Start Date</mat-label>
          <input [readonly]="isReadonly" matInput formControlName="startDate" [max]="yearCycleForm.controls.endDate.value" (click)="picker1.open()" [matDatepicker]="picker1"
            [min]="minDate" required>
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker [disabled]="isReadonly" #picker1></mat-datepicker>
          <mat-error *ngIf="yearCycleForm.get('startDate').hasError('required')">
            Please enter start date
          </mat-error>
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>End Date</mat-label>
          <!-- <input matInput [min]="yearCycleForm.controls.startDate.value" formControlName="endDate" (click)="picker2.open()" [matDatepicker]="picker2" [min]="todayDate" -->
          <input matInput [readonly]="isReadonly"  [min]="yearCycleForm.controls.startDate.value ? yearCycleForm.controls.startDate.value : minDate" formControlName="endDate" (click)="picker2.open()" [matDatepicker]="picker2" 
            required>
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker [disabled]="isReadonly" #picker2></mat-datepicker>
          <mat-error *ngIf="yearCycleForm.get('endDate').hasError('required')">
            Please enter cycle end date
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Waiver Limit</mat-label>
          <input id = 'limit' type="number" min="1" max="99" (keydown)="numberOnly($event)" matInput formControlName="limit" required />
          <mat-error *ngIf="yearCycleForm.get('limit').hasError('required')">
            Please enter limit
          </mat-error>
          <mat-error *ngIf="yearCycleForm.controls['limit'].hasError('min')">
            Minimum required number is 1.
           </mat-error>
          <!-- <mat-error *ngIf="!yearCycleForm.get('limit').hasError('required') && yearCycleForm.get('limit').hasError('pattern')">
            Limit max length is 2
          </mat-error> -->
        </mat-form-field>
        <!-- <mat-form-field  appearance="fill">
                <mat-label>Cycles</mat-label>
                <mat-select formControlName="cycleId" [disabled]='yearCycleForm.controls.year.value == 2020'>
                  <mat-option  *ngFor="let cycle of cycles" [value]="cycle.id">{{cycle.cycle}}</mat-option>
                </mat-select>
                <mat-error *ngIf="yearCycleForm.get('cycleId').hasError('required')">
                   Please select cycle    
                 </mat-error>
             </mat-form-field> -->
        <!-- <mat-form-field  appearance="fill">
                <mat-label>City Name</mat-label>
                <input matInput formControlName="city" required/>
                <mat-error *ngIf="addressForm.get('city').hasError('required')">
                   Please enter
                   <strong>City Name</strong>
                 </mat-error>
             </mat-form-field> -->
        <!-- <mat-form-field  appearance="fill">
                <mat-label>State</mat-label>
                <input matInput formControlName="state" required/>
                <mat-error *ngIf="addressForm.get('state').hasError('required')">
                   Please enter
                   <strong>State</strong>
                 </mat-error>
             </mat-form-field> -->
        <!-- <mat-form-field  appearance="fill">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="zipcode" required/>
                <mat-error *ngIf="addressForm.get('zipcode').hasError('required')">
                   Please enter
                   <strong>Zip Code</strong>
                 </mat-error>
             </mat-form-field> -->
        <button mat-button *ngIf="!selectedItem" class="button-primary" [disabled]='yearCycleForm.invalid || yearCycleForm.controls.limit.value >99 || yearCycleForm.controls.limit.value <= 0' type="submit"
          color="vov-ui-primary">Submit</button>
        <button mat-button *ngIf="selectedItem" class="button-primary" [disabled]='yearCycleForm.invalid || yearCycleForm.controls.limit.value >99 || yearCycleForm.controls.limit.value <= 0' type="submit"
          (click)="editYearCycle($event)" color="vov-ui-primary">Update</button>
      </form>
    </mat-dialog-content>
  </div>
</ng-template>
<ng-template #confirmRef>
  <div class="dialog-Container">
    <h3 mat-dialog-title>Are you sure you want to delete?</h3>
    <mat-dialog-content class="delete-Conatiner">
      <button mat-button color="vov-ui-primary" class="confirm-btn confirm" (click)="confirmDelete()">Delete</button>
      <button mat-button (click)="onNoClick()" class="confirm-btn cancel" tabindex="-1">Cancel</button>
    </mat-dialog-content>
  </div>
</ng-template>
